import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../components/common/faq";

const faqs = [
  {
    question: "Do mobile apps need maintenance?",
    answer: `<p>If you avoid the update of your app through the Play Store over an extended period, you might encounter various potential challenges:</p><ul>
    <li><strong>Security vulnerabilities:</strong> Outdated versions of apps may harbor security weaknesses. It makes your device and personal information more vulnerable to cyber threats.</li>
    <li><strong>Performance concerns:</strong>Apps that haven't been updated may not function as efficiently as their more recent counterparts. It results in slower performance, crashes, or other technical glitches.</li>
    <li><strong>Compatibility problems:</strong> With the continuous evolution of the Android operating system, older app versions might become incompatible with newer system updates, leading to functionality issues.</li>
    <li><strong>Losing new features:</strong> App updates often bring new features, enhancements, and bug fixes that elevate the user experience. Ignoring updates means missing out on these valuable improvements.</li>
    </ul>`,
  },
  {
    question: "How long does it take to maintain an app?",
    answer:`<p>If you opt to extend the development process and incorporate features less frequently, you can aim for a monthly commitment of 10-15 hours. While expert programmers may require less time for your app and come with a higher cost. Moreover, the investment becomes worthwhile if you intend to keep the app active and implement regular updates.</p>`,
  },
  {
    question: "How much does it cost for mobile app maintenance?",
    answer: `<p>Typically, app proprietors can anticipate an initial monthly expense ranging from $250 to $500 to maintain optimal app functionality. A common rule of thumb is to allocate 20% of the initial development cost for ongoing maintenance.</p>`,
  },
  {
    question: "How often should a mobile app be updated?",
    answer: `<p>In broad terms, a favorable frequency is making 1-2 minor enhancements each month. These enhancements encompass minor upgrades, redesigns, and the addition of new features. Consistent improvements prove more beneficial than extensive overhauls of the app. Nevertheless, the rate of app updates may vary based on your objectives and the functionality of the app.</p>`,
  },

];

function FaqLocation(props) {


  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>App Maintenance and Support Services FAQs</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs}/>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
